// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__9gw6J","selects":"Documents_selects__2J66z"};